'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'zh', name: '繁體中文', flag: '🇭🇰' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 0.5,
      }}
    >
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <Typography
          component="span"
          sx={{ fontSize: 28, lineHeight: 1, mt: 0.5 }}
        >
          {current.flag}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center'}}>
          <Typography
            variant="caption"
            sx={{ color: '#a98c74', fontWeight: 400, fontSize: 14 }}
          >
            {current.name}
          </Typography>
          <ExpandMoreIcon sx={{ color: '#a98c74', fontSize: 18 }} />
        </Box>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {languages.map(language => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={i18n.language === language.code}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography component="span" sx={{ fontSize: 22, lineHeight: 1, mr: 1.5, py: 1 }}>
              {language.flag}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: '#a98c74', fontWeight: 400, fontSize: 14 }}
            >
              {language.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
